import { RecordModule } from './modules/record';
import { RrwebAdapter } from './modules/record/rrwebAdapter';
import './browser';

RecordModule.registerAdapter(new RrwebAdapter());
